import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/cosmetic-gynecology/")({
  beforeLoad: () => {
    throw redirect({
      to: "/specialties/$slug",
      params: { slug: "cosmetic-gynaecology" },
      replace: true,
      statusCode: 301,
    });
  },
});
